/**
 * LogConsole.jsx — Real-time log console with auto-scroll.
 * Colors: INFO=grey, WARN=yellow, ERROR=red, DONE=green.
 */

import { useEffect, useRef } from "react";

export default function LogConsole({ logs = [] }) {
  const consoleRef = useRef(null);

  useEffect(() => {
    const el = consoleRef.current;
    if (!el) return;
    el.scrollTop = el.scrollHeight;
  }, [logs.length]);

  return (
    <div className="hm-section">
      <div className="hm-section__header">
        <span className="hm-section__title">
          🖥 Monitor &amp; Logs
          <span className="hm-section__badge">{logs.length}</span>
        </span>
        <span style={{ fontSize: 11, color: "var(--text-tertiary)" }}>
          Live system output — last {logs.length} lines
        </span>
      </div>

      <div className="hm-log-console" ref={consoleRef}>
        {logs.length === 0 ? (
          <div style={{ color: "#4B5563", fontStyle: "italic" }}>
            Waiting for events… <span className="hm-log-blink" />
          </div>
        ) : (
          <>
            {logs.map((entry, i) => {
              const { ts, msg } = typeof entry === "object" ? entry : { ts: "", msg: entry };
              const cls = lineClass(msg);
              return (
                <div key={i} className={`hm-log-line hm-log-line--${cls}`}>
                  <span className="hm-log-ts">{ts}</span>
                  <span className="hm-log-msg">{msg}</span>
                </div>
              );
            })}
            <span className="hm-log-blink" />
          </>
        )}
      </div>
    </div>
  );
}

function lineClass(msg = "") {
  const m = msg.toLowerCase();
  if (m.includes("error") || m.includes("fail"))     return "error";
  if (m.includes("warn"))                            return "warn";
  if (m.includes("complete") || m.includes("done"))  return "done";
  return "info";
}
